import React from "react";
import {
  withStyles,
  Theme,
  WithStyles,
  createStyles,
} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Typography from "../components/Typography";
import Paper from "../components/Paper";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      marginTop: theme.spacing(8),
      marginBottom: theme.spacing(8),
    },
    title: {
      marginBottom: theme.spacing(4),
    },
    paper: {
      padding: theme.spacing(4),
    },
    list: {
      margin: 0,
      paddingLeft: theme.spacing(3),
    },
    listItem: {
      marginBottom: theme.spacing(1.5),
    },
  });

const points = [
  "Dubslack uses Slack's official OAuth authentication to connect each workspace.",
  "Dubslack never asks for or stores your Slack password.",
  "Only the permissions required for status and presence synchronization are requested.",
  "You can remove any connected workspace from within the app at any time.",
];

function InstallSecurity(props: WithStyles<typeof styles>) {
  const { classes } = props;

  return (
    <Container className={classes.container}>
      <Typography variant="h4" marked="center" align="center" className={classes.title}>
        Security
      </Typography>
      <Paper background="light" className={classes.paper}>
        <ul className={classes.list}>
          {points.map((point, index) => (
            <li className={classes.listItem} key={index}>
              <Typography variant="body1">{point}</Typography>
            </li>
          ))}
        </ul>
      </Paper>
    </Container>
  );
}

export default withStyles(styles)(InstallSecurity);
